import { buildAuthenticationHeaders } from "@src/cloud-connect/api/util/build-authentication-headers";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { i18n } from "@src/i18n/i18n";

async function downloadLicensedConfiguration(fileUrl: string, id: string) {
  const fileName = `tomorrowthings-configuration-for-licencse-${id}.bin`;
  try {
    const response = await fetch(fileUrl, {
      method: "POST",
      headers: buildAuthenticationHeaders(),
    });

    if (!response.ok) throw new Error("Network response was not ok.");

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error(err);
    errorSnackbar(i18n("pages.configurationManager.downloadError"));
  }
}

export default downloadLicensedConfiguration;
